// river high water for one rise: seeds with per-section / per-river protection heights, flood image, outfalls with backwater
import { riverSeeds, riverFlood, riverDepth, floodImage } from './floodDem';

const num = (v) => (v == null || v === '' || !Number.isFinite(+String(v).replace(',', '.')) ? null : +String(v).replace(',', '.'));
// "1; 2; 3" or "1,5 2" -> sorted unique rises (max 5); a comma followed by a space separates, otherwise it is the decimal mark
export const parseRises = (s) => [...new Set(String(s || '').split(/\s*;\s*|,\s+|\s+|\//).map(num).filter((v) => v > 0))].sort((a, b) => a - b).slice(0, 5);
// protection of a section: own value > value of the river name > general value
export const effDyke = (r, byName, gen) => num(r.dyke) ?? num(byName?.[r.name]) ?? gen;

export function riverRun(G, F, rivers, byName, rise, gen) {
  const list = rivers.map((r) => ({ ...r, dyke: effDyke(r, byName, gen) }));
  const R = riverFlood(G, riverSeeds(G, list, rise, gen)), riv = floodImage(G, { depth: riverDepth(G, R) }, 'river');
  // backwater: river level of the nearest section above the outfall invert (also behind a dyke, the river itself rises)
  const back = F.filter((f) => f.hyd?.out || ['KA', 'NÜL'].includes(f.sym)).map((f) => {
    const i = G.at(f.lat, f.lon), lv = i >= 0 ? R.own[i] : NaN, rim = num(f.elev?.v), inv = num(f.hyd?.inv) ?? (rim != null ? rim : G.z[i]) - (num(f.depth) || 2);
    return { fid: f.id, name: f.name, lv, inv, over: lv - inv };
  }).filter((x) => Number.isFinite(x.lv) && x.over > 0);
  return { river: Object.assign(riv, { dry: R.dry, rise, dyke: gen }), back };
}
